module.exports = __webpack_public_path__ + "img/img-placeholder.2d4c9d1c.svg";